import { render, staticRenderFns } from "./LabelPickerInformation.vue?vue&type=template&id=0c2742b8"
import script from "./LabelPickerInformation.vue?vue&type=script&lang=ts"
export * from "./LabelPickerInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports